import React, { Dispatch, SetStateAction } from 'react';
import {
  View, Text, Pressable, StyleSheet, ScrollView,
} from 'react-native';
import { FontAwesome } from '@expo/vector-icons';
import Style from '../../../../../constants/Style';
import {
  AssetSortCategory, AssetSortCategoryTitles,
} from '../../../../../requests/Assets/GetAssets';
import Colors from '../../../../../constants/Colors';
import { PressableState } from '../../../../../components/PressableStyled';

interface AssetSortSelectionProps {
  selectedSortCategory: AssetSortCategory,
  setSelectedSortCategory: Dispatch<SetStateAction<AssetSortCategory>>,
  sortDescendingSelected: boolean,
  setSortDescendingSelected: Dispatch<SetStateAction<boolean>>,
  sortCategoryDropdownToggled: boolean,
  setSortCategoryDropdownToggled: Dispatch<SetStateAction<boolean>>,
  sortOrderDropdownToggled: boolean,
  setSortOrderDropdownToggled: Dispatch<SetStateAction<boolean>>,
  closeFilterDropdowns: () => void,
}

const AssetSortSelection = ({
  selectedSortCategory, setSelectedSortCategory, sortDescendingSelected, setSortDescendingSelected,
  sortCategoryDropdownToggled, setSortCategoryDropdownToggled, sortOrderDropdownToggled,
  setSortOrderDropdownToggled, closeFilterDropdowns,
}: AssetSortSelectionProps) => <View style={styles.container}>
    <View style={{ flex: 1 }}>
      <Pressable
        style={styles.dropdownButton}
        onPress={() => {
          setSortCategoryDropdownToggled(!sortCategoryDropdownToggled);
          setSortOrderDropdownToggled(false);
          closeFilterDropdowns();
        }}
      >
        <Text style={Style.dropdownText}>
          {selectedSortCategory ? AssetSortCategoryTitles[selectedSortCategory] : 'Select category'}
        </Text>
        <FontAwesome
          name={sortCategoryDropdownToggled ? 'angle-up' : 'angle-down'}
          size={24}
          color={Colors.light.hereworksBlue500}
        />
      </Pressable>
      <View>
        {sortCategoryDropdownToggled && <ScrollView style={styles.dropdownContent}>
          {Object.values(AssetSortCategory).map((item: AssetSortCategory) => <Pressable
            style={({ hovered, pressed }: PressableState) => [
              styles.menuItem,
              hovered && Style.listItemHovered, pressed && Style.listItemPressed,
            ]}
            onPress={() => {
              setSelectedSortCategory(item);
              setSortCategoryDropdownToggled(false);
              closeFilterDropdowns();
            }}
            key={`category_${item}`}
          >
            <Text style={Style.dropdownText}>{AssetSortCategoryTitles[item]}</Text>
          </Pressable>)}
        </ScrollView>}
      </View>
    </View>
    <View style={{ flex: 1, marginStart: 8 }}>
      <Pressable
        style={styles.dropdownButton}
        onPress={() => {
          setSortCategoryDropdownToggled(false);
          setSortOrderDropdownToggled(!sortOrderDropdownToggled);
          closeFilterDropdowns();
        }}
      >
        <Text style={Style.dropdownText}>
          {sortDescendingSelected ? 'Descending' : 'Ascending'}
        </Text>
        <FontAwesome
          name={sortOrderDropdownToggled ? 'angle-up' : 'angle-down'}
          size={24}
          color={Colors.light.hereworksBlue500}
        />
      </Pressable>
      <View>
        {sortOrderDropdownToggled && <ScrollView style={styles.dropdownContent}>
          {['Ascending', 'Descending'].map((item: string, index: number) => <Pressable
            style={({ hovered, pressed }: PressableState) => [
              styles.menuItem,
              hovered && Style.listItemHovered, pressed && Style.listItemPressed,
            ]}
            onPress={() => {
              setSortDescendingSelected(index === 1);
              setSortOrderDropdownToggled(false);
              closeFilterDropdowns();
            }}
            key={`category_${index}`}
          >
            <Text style={Style.dropdownText}>{item}</Text>
          </Pressable>)}
        </ScrollView>}
      </View>
    </View>
  </View>;

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
  dropdownButton: {
    ...Style.dropdown,
    ...Style.row,
    paddingHorizontal: 12,
    paddingVertical: 9,
    marginVertical: 6,
  },
  dropdownContent: {
    ...Style.dropdown,
    flexDirection: 'column',
    alignItems: undefined,
    height: undefined,
  },
  menu: {
    marginEnd: 8,
    alignSelf: 'stretch',
  },
  menuItem: {
    paddingHorizontal: 12,
    paddingVertical: 9,
    alignSelf: 'stretch',
  },
});

export default AssetSortSelection;
